import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'noThousandsSeparator'
})
export class NoThousandsSeparatorPipe implements PipeTransform {
    transform(value: number): string {
        return Math.round(value).toString();
    }
}
